import { Folder } from "lucide-react";
import type { DestinationOptionLabelProps } from "./types";

export const DestinationOptionLabel = ({
  name,
}: DestinationOptionLabelProps) => (
  <span className="flex min-w-0 items-center gap-2">
    <Folder size={16} className="flex-shrink-0 text-gray-400" />
    <span className="truncate">{name}</span>
  </span>
);
